<div class="alert-content" mat-dialog-content>
    <p i18n="InfoAlert| inform user that they should wait until settlement to be able to mark card transaction as debt">Wait until transaction will be processed by MasterCard. Try again later.</p>
</div>
<mat-dialog-actions class="red-alert-actions">
    <button mat-button class="mat-primary" tabindex="-1" (click)="confirm()">OK</button>
</mat-dialog-actions>
